import axios from 'axios';
import Vue from 'vue';
import { baseURL, xToken } from './env/env.json';
// eslint-disable-next-line import/no-cycle
import store from './store/storage';
// eslint-disable-next-line import/no-cycle
import router from './routes';

const baseApiURL = process.env.NODE_ENV === 'production'
  // eslint-disable-next-line no-restricted-globals
  ? `${location.protocol}//${location.hostname}${location.port ? `:${location.port}` : ''}/api`
  : baseURL;

const defaultRequest = (instance, state) => {
  instance.interceptors.request.use(
    (config) => {
      if (state.token !== undefined && state.token) {
        config.headers.Authorization = `Bearer ${state.token}`;
      }
      state.loading = true;
      return config;
    },
    error => Promise.reject(error),
  );
  return instance;
};

const defaultResponse = (instance, state) => {
  instance.interceptors.response.use(
    (response) => {
      state.loading = false;
      // Не очищаем ошибки при успешном ответе, если пользователь не залогинен —
      // иначе подсказка «неверный логин или пароль» сразу скрывается
      // из-за GetSettings после UserLogout
      if (state.profile_id) {
        Vue.notify({ group: 'error', clean: true });
      }
      return response;
    },
    (error) => {
      state.loading = false;
      if (error.response && error.response.status === 401) {
        store.dispatch('UserLogout');
        if (router.currentRoute.path !== '/') {
          router.push('/', () => {
            if (error.response.data && error.response.data.error) {
              const text = `<i class="v-icon v-icon--left material-icons mr-1" style="vertical-align:bottom"></i> ${error.response.data.error}`;
              Vue.notify({ group: 'info', type: 'error', text, duration: 7000 });
            }
          });
        }
      } else if (error.response && error.response.status === 403) {
        store.dispatch('UserLogout');
        if (router.currentRoute.path !== '/') {
          router.push('/', () => {
            const message = (error.response.data && error.response.data.error)
              ? error.response.data.error
              : 'Ваш аккаунт заблокирован. Обратитесь к администратору.';
            const text = `<i class="v-icon v-icon--left material-icons mr-1" style="vertical-align:bottom"></i> ${message}`;
            Vue.notify({ group: 'info', type: 'error', text, duration: 7000 });
          });
        }
      } else {
        Vue.notify({ group: 'error', clean: true });
      }


      return Promise.reject(error);
    },
  );

  return instance;
};

// eslint-disable-next-line import/prefer-default-export
export const ax = (state) => {
  const instance = axios.create({
    baseURL: baseApiURL,
    timeout: 60000,
    headers: { 'Content-Type': 'application/json', 'X-Token': xToken },
  });
  defaultRequest(instance, state);
  defaultResponse(instance, state);

  return instance;
};

export const axl = (state) => {
  const instance = axios.create({
    baseURL: baseApiURL,
    timeout: 60000,
    headers: { 'Content-Type': 'application/json', 'X-Token': xToken },
  });
  defaultRequest(instance, state);
  defaultResponse(instance, state);
  return instance;
};

export const axf = (state) => {
  const instance = axios.create({
    baseURL,
    timeout: 60000,
    headers: { 'Content-Type': 'application/json', 'X-Token': xToken },
    responseType: 'blob',
  });
  defaultRequest(instance, state);
  defaultResponse(instance, state);
  return instance;
};
